"use strict"

angular.module("customer")
.service("CommissionService", function($resource, FlashBag, appConfig) {
    var resource = $resource(appConfig.API_SERVER + "/invoice/customer/commissions/", {}, {
        query: {
            method: "GET",
            isArray: true,
            interceptor: {responseError: FlashBag.responseErrorInterceptor}
        }
    });

    this.query = function(params) {
        return resource.query(params);
    };

    var userVendorResource = $resource(appConfig.API_SERVER + "/invoice/customer/commissions/vendor/", {}, {
        get: {
            method: "GET",
            isArray: false,
            interceptor: {responseError: FlashBag.responseErrorInterceptor}
        }
    });

    this.getUserVendor = function(params) {
        return userVendorResource.get(params);
    };
});



//////////////////
// WEBPACK FOOTER
// ./customer/sections/commission/commission.service.js
// module id = 908
// module chunks = 0